(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-description.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-description.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class RowDescription extends svs.tur.Base {
  constructor(_ref) {
    let {
      title,
      description,
      price,
      when,
      tv,
      winInfo
    } = _ref;
    super({
      className: 'ball-row-description'
    });
    this.title = title;
    this.description = description;
    this.price = price;
    this.when = when;
    this.tv = tv;
    this.winInfo = winInfo;
    this.render();
  }
  render() {
    const descArr = ["<div class=\"ng-header-small f-medium\">".concat(this.title, "</div>")];
    if (this.description) descArr.push(this.description);
    if (this.price) descArr.push(this.price);
    if (this.when) descArr.push("".concat(this.tv ? svs.ui.icon.partials.icon({
      icon: 'tv'
    }) : '').concat(this.when));
    const joinWithComma = _ref2 => {
      let [first, ...rest] = _ref2;
      return "".concat(first, " ").concat(rest.join(', '));
    };
    let str = joinWithComma(descArr);
    if (this.winInfo) {
      str += "<div class=\"ball-row-description-extra\">\n              ".concat(this.winInfo.map((str, index) => index ? "<br />+ ".concat(str) : str).join(''), "\n              </div>");
    }
    this.$el.innerHTML = str;
    return this.$el;
  }
}
svs.tur.ball.row.extensions.Description = RowDescription;

 })(window);